export const VERSION_POLL_INTERVAL_MS = 60_000;
export const VERSION_URL = '/version.json';
export const COUNTDOWN_DURATION_SECONDS = 60;
export const SNOOZE_DURATION_MS = 5 * 60_000;
export const UPDATE_TOAST_ID = 'version-update-available';
export const VERSION_RELOAD_OVERRIDE_KEY = 'versionReloadEnabled';
